// getters.js

export default {
    getCompanyList(state){
        return state.companyList
    },
    getCurrentCompany(state){
        return state.currentCompany
    }
};
